import React, { useEffect, useMemo, useState } from 'react';
import './Sanklanreportprint.css';
import axios from 'axios';
import { Document, Page, Text, View, StyleSheet, PDFViewer, Image } from '@react-pdf/renderer';
import { Font } from '@react-pdf/renderer';
import LatoItalicFont from "../../Fonts/Baloo2-VariableFont_wght.ttf";
import Logo from "../../imgs/dairylogo.png";
import { useTranslation } from "react-i18next";
import NotoSansKannada from "../../Fonts/NotoSansKannada.ttf";

Font.register({
  family: 'Lato-Italic',
  src: LatoItalicFont,
});
Font.register({
  family: "Kannada",
  src: NotoSansKannada,
});

// ✅ styles factory (so fontBase is defined)
const createStyles = (fontBase) =>
  StyleSheet.create({
    page: {
      paddingTop: 10,
      flexDirection: 'row',
      justifyContent: 'center', // Center horizontally
    },
    header: {
      position: 'absolute',
      top: 0, // Adjust this value to change the vertical position
      left: 0,
      right: 0,
      textAlign: 'center',
    },
    tableContainer: {
      display: 'flex',
      flexDirection: 'row',
      width: '100vw',
      justifyContent: 'space-between',
    },
    table: {
      display: 'table',
      width: '97%', // Adjust as needed to fit four tables in a row
      margin: 5,
    },
    tableone: {
      display: 'table',
      width: '18%', // Adjust as needed to fit four tables in a row
      margin: 5,
    },
    tableCellone: {
      border: '0.5px solid lightgray',
      padding: 0.5,
      fontSize: 8,
      fontFamily: fontBase,
      textAlign: 'center',
      flex: 1, // Remove width and use flex to distribute space equally
    },
    tableRowone: {
      flexDirection: 'row',
      width: '100%',
    },
    tableHeaderone: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      border: '1px solid #000',
      padding: 2,
      fontSize: 8,
      textAlign: 'center',
      flex: 1, // Remove width and use flex to distribute space equally
    },

    tableRow: {
      flexDirection: 'row',
    },
    tableRow2: {
      flexDirection: 'row',
      backgroundColor: 'lightgray',
      marginTop: 5,
    },

    tableRow3: {
      flexDirection: 'row',
      backgroundColor: 'lightgray',
      marginTop: 10,
    },
    line: {
      flexDirection: 'row',
      backgroundColor: 'lightgray',
      marginTop: 5,
      height: 1,
      width: '100vw',
      marginBottom: 5,
    },
    thgroup: {
      fontFamily: fontBase,
      fontWeight: 'bold',
    },
    tableHeader: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 1, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      borderStyle: 'solid', // Set the border style to 'solid'
      padding: 2,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 9,
    },
    tableHeadervadhtut: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 1, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      borderStyle: 'solid', // Set the border style to 'solid'
      padding: 2,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 8,
    },

    tableHeadervadhtutspan: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 1, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 0,  // No border for right side
      borderStyle: 'solid', // Set the border style to 'solid'
      padding: 2,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
    },

    tableHeadervadhtutlast: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 1, // Add border only for bottom side
      borderLeftWidth: 0,   // Add border only for left side
      borderRightWidth: 1,  // No border for right side
      borderStyle: 'solid', // Set the border style to 'solid'
      padding: 2,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 8,
    },

    tableHeadervadhtutlastspan: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 1, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 1,  // No border for right side
      borderStyle: 'solid', // Set the border style to 'solid'
      padding: 2,
      flex: 0.5,
      borderColor: 'lightblack',
      textAlign: 'center',
      fontSize: 10,
    },

    tableHeaderlast: {
      fontFamily: fontBase,
      fontWeight: 'bold',
      borderTopWidth: 1,    // Add border only for top side
      borderBottomWidth: 1, // Add border only for bottom side
      borderLeftWidth: 1,   // Add border only for left side
      borderRightWidth: 1,  // No border for right side
      borderStyle: 'solid', // Set the border style to 'solid'
      borderColor: 'lightblack',
      padding: 2,
      flex: 0.5,
      textAlign: 'center',
      fontSize: 9,
    },
    tableCell: {
      border: '0.5px solid lightgray',
      padding: 0.5,
      flex: 1,
      fontSize: 10,
      fontFamily: fontBase,
      width: 2,
      textAlign: 'center',
    },
    tableCellvadhtut: {
      border: '0.5px solid lightgray',
      padding: 0.5,
      flex: 1,
      fontSize: 8,
      fontFamily: fontBase,
      width: 2,
      textAlign: 'center',
    },
    tableCellgreen: {
      border: '0.5px solid lightgray',
      padding: 0.5,
      flex: 1,
      fontSize: 10,
      fontWeight: 'bold',
      fontFamily: fontBase,
      color: 'green',
      width: 2,
      textAlign: 'center',
    },
    tableCellred: {
      border: '0.5px solid lightgray',
      padding: 0.5,
      flex: 1,
      fontSize: 9,
      fontWeight: 'bold',
      fontFamily: fontBase,
      color: 'red',
      width: 2,
      textAlign: 'center',
    },
    latoTextlarge: {
      fontFamily: fontBase,
      fontSize: 15,
      marginBottom: 5,
      textAlign: 'center',
      width: '100vw',
      fontWeight: 'bold',
      marginTop: 5,
    },
    latoText: {
      fontFamily: fontBase,
      fontSize: 14,
      marginBottom: 5,
      textAlign: 'center',
      width: '100vw',
      fontWeight: 'bold',
      marginTop: 5,
    },
    latoText2: {
      fontFamily: fontBase,
      fontSize: 11,
      textAlign: 'center',
      width: '100vw',
      fontWeight: 'bold',
    },
    headtextsmall: {
      fontFamily: fontBase,
      fontSize: 10,
      fontWeight: 'bold',
    },
    row: {
      display: 'flex',
      flexDirection: 'row',
      width: '100vw',
    },
    row1: {
      display: 'flex',
      flexDirection: 'row',
      width: '100vw',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingLeft: 5,
      paddingRight: 5,
    },
    row2: {
      display: 'flex',
      flexDirection: 'row',
      width: '100vw',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingLeft: 140,
      paddingRight: 140,
      backgroundColor: 'lightgray',
    },
    column1: {
      display: 'flex',
      flexDirection: 'column',
      width: '19%',
      justifyContent: 'start',
      alignItems: 'flex-start', // Align text to the left
      paddingLeft: 5,
      paddingRight: 5,
      marginLeft: 20,
    },
    column2: {
      display: 'flex',
      flexDirection: 'column',
      width: '15%',
      justifyContent: 'start',
      alignItems: 'flex-start', // Align text to the left
      paddingLeft: 5,
      paddingRight: 5,
    },
    column3: {
      display: 'flex',
      flexDirection: 'column',
      width: '17%',
      justifyContent: 'start',
      alignItems: 'flex-start', // Align text to the left
      paddingLeft: 5,
      paddingRight: 5,
      marginLeft: 20,
    },
    column1Row: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
    },
    column1Rowgray: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      padding: 6,
      marginTop: 5,
      border: '0.5px solid black',
      backgroundColor: 'lightgray'
    },
    column1Label: {
      fontFamily: fontBase,
      fontSize: 9,
      fontWeight: 'bold',
      textAlign: 'left', // Align labels to the left
    },
    column1Value: {
      fontFamily: fontBase,
      fontSize: 9,
      fontWeight: 'bold',
      textAlign: 'right', // Align values to the right
    },
    pageBreak: {
      pageBreakBefore: 'always',
    },
    totalsRow: {
      flexDirection: 'row',
      borderTop: '1px solid #000',
      paddingTop: 5,
      paddingLeft: 2,
    },
    totalsCell: {
      border: '0.5px solid lightgray',
      padding: 0.5,
      flex: 1,
      fontSize: 8,
      width: 2,
      textAlign: 'center',
    },
    imagerow: {
      display: 'flex',
      flexDirection: 'row',
      width: '100vw',
      justifyContent: 'center',
      alignItems: 'center',
    },
    image: {
      width: 80, // Adjust the width as needed
      height: "auto", // Maintain aspect ratio
      marginLeft: -15,
      marginTop: 5
    },
    imgtext: {
      fontFamily: fontBase,
      fontSize: 9,
      fontWeight: 'bold',
      textAlign: 'center', // Align labels to the left
    },
  });

const Sanklanreportprint = () => {
  const { t, i18n } = useTranslation();

  // ✅ language + font selection (Kannada font when kn)
  const lang = i18n?.language || localStorage.getItem("i18nextLng") || "mr";
  const fontBase = (lang || "").toLowerCase().startsWith("kn") ? "Kannada" : "Lato-Italic";

  // ✅ styles now uses fontBase safely
  const styles = useMemo(() => createStyles(fontBase), [fontBase]);

  const [customerData, setCustomerData] = useState({});
  const [literTotal, setLiterTotal] = useState(0);
  const [amtTotal, setAmtTotal] = useState(0);
  let totals = {};

  useEffect(() => {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    let phplanding = "";
    console.log(localStorage.getItem("rtype"));
    if (localStorage.getItem("rtype") === "all") {
      phplanding = "getsanklanreport2.php";
    }
    else if (localStorage.getItem("rtype") === "bydate" && localStorage.getItem("showmasik") === "false") {
      phplanding = "getvadhtut3.php";
    }
    else if (localStorage.getItem("rtype") === "bydate" && localStorage.getItem("showmasik") === "true") {
      phplanding = "getvadhtut4.php";
    }

    let rawData = {
      date1: localStorage.getItem("date1print"),
      date2: localStorage.getItem("date2print"),
      kno: localStorage.getItem("searchsank"),
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
    }
    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)
    axios.post(`https://excellentdairy.com/dairy/php/cust/${phplanding}`, formData, {
      'Content-Type': 'multipart/form-data',
    }).then(function sample(response) {
      setCustomerData(response.data);
    }).catch(err => {
      console.log(err);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getDatesInRange = (date1, date2) => {
    const dates = [];
    const currentDate = new Date(date1);

    while (currentDate <= new Date(date2)) {
      dates.push(currentDate.toISOString().split('T')[0]);
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return dates;
  };

  function formatDate(inputDate) {
    const options = { day: '2-digit', month: 'short' };
    return new Date(inputDate).toLocaleDateString('en-US', options);
  }

  if (localStorage.getItem("rtype") === "all") {
    if (Array.isArray(customerData) && customerData.length > 0) {
      totals = {
        tliter: customerData.reduce((total, rowData) => total + parseFloat(rowData.liter), 0),
        tamt: customerData.reduce((total, rowData) => total + parseFloat(rowData.amt), 0),
      };
    }
  }
  else if (localStorage.getItem("rtype") === "bydate") {
    if (Array.isArray(customerData) && customerData.length > 0) {
      totals = {
        tmhliter: customerData.reduce((total, rowData) => total + parseFloat(rowData.mhliter), 0),
        tsanghtotalmh: customerData.reduce((total, rowData) => total + parseFloat(rowData.sanghtotalmh), 0),

        tdlitermh: customerData.reduce((total, rowData) => total + parseFloat(rowData.dlitermh), 0),
        tvaslitermh: customerData.reduce((total, rowData) => total + parseFloat(rowData.vaslitermh), 0),
        ttotalratibmh: customerData.reduce((total, rowData) => total + parseFloat(rowData.totalratibmh), 0),
        ttotalratibmhsabh: customerData.reduce((total, rowData) => total + parseFloat(rowData.totalratibmhsabh), 0),
        tmhamt: customerData.reduce((total, rowData) => total + parseFloat(rowData.mhamt), 0),

        tsanghamtmh: customerData.reduce((total, rowData) => total + parseFloat(rowData.sanghamtmh), 0),
        tdamtmh: customerData.reduce((total, rowData) => total + parseFloat(rowData.damtmh), 0),
        tvasamtmh: customerData.reduce((total, rowData) => total + parseFloat(rowData.vasamtmh), 0),
        tratibamtmh: customerData.reduce((total, rowData) => total + parseFloat(rowData.ratibamtmh), 0),

        tvadhtutmh: customerData.reduce((total, rowData) => total + parseFloat(rowData.vadhtutmh), 0),
        tvadhtutmhamt: customerData.reduce((total, rowData) => total + parseFloat(rowData.vadhtutmhamt), 0),
        tgayliter: customerData.reduce((total, rowData) => total + parseFloat(rowData.gayliter), 0),
        tsanghtotalgay: customerData.reduce((total, rowData) => total + parseFloat(rowData.sanghtotalgay), 0),

        tdlitergay: customerData.reduce((total, rowData) => total + parseFloat(rowData.dlitergay), 0),
        tvaslitergay: customerData.reduce((total, rowData) => total + parseFloat(rowData.vaslitergay), 0),
        ttotalratibgay: customerData.reduce((total, rowData) => total + parseFloat(rowData.totalratibgay), 0),
        ttotalratibgaysabh: customerData.reduce((total, rowData) => total + parseFloat(rowData.totalratibgaysabh), 0),
        tgayamt: customerData.reduce((total, rowData) => total + parseFloat(rowData.gayamt), 0),
        tsanghamtgay: customerData.reduce((total, rowData) => total + parseFloat(rowData.sanghamtgay), 0),
        tdamtgay: customerData.reduce((total, rowData) => total + parseFloat(rowData.damtgay), 0),

        tvasamtgay: customerData.reduce((total, rowData) => total + parseFloat(rowData.vasamtgay), 0),
        tratibamtgay: customerData.reduce((total, rowData) => total + parseFloat(rowData.ratibamtgay), 0),
        tvadhtutgay: customerData.reduce((total, rowData) => total + parseFloat(rowData.vadhtutgay), 0),
        tvadhtutgayamt: customerData.reduce((total, rowData) => total + parseFloat(rowData.vadhtutgayamt), 0),
      };
    }
  }

  var jsEncode = {
    encode: function (s, k) {
      var enc = "";
      // Make sure that the input is a string
      var str = s.toString();
      for (var i = 0; i < str.length; i++) {
        // Create block
        var a = str.charCodeAt(i);
        // Bitwise XOR
        var b = a ^ k;
        enc = enc + String.fromCharCode(b);
      }
      return enc;
    }
  };

  return (
    <PDFViewer className='pdf'>
      <Document>

        {customerData.length > 0 ? (
          localStorage.getItem("rtype") === "all"
            ?
            <Page size="A4" orientation="landscape">
              <Text style={styles.latoText}>{customerData[0].kendra}</Text>
              <Text style={styles.latoText}>{t("sanklanreportprint.titles.sanklanReport")}</Text>
              <Text style={styles.latoText2}>
                {t("sanklanreportprint.period", {
                  from: formatDate(localStorage.getItem("date1print")),
                  to: formatDate(localStorage.getItem("date2print")),
                })}
              </Text>

              <View style={styles.table}>
                {/* Table Header */}
                <View style={styles.tableRow}>
                  <Text style={styles.tableHeader}>{t("common.table.date")}</Text>
                  <Text style={styles.tableHeader}>{t("common.table.name")}</Text>
                  <Text style={styles.tableHeader}>{t("common.table.time")}</Text>
                  <Text style={styles.tableHeader}>{t("common.table.type")}</Text>
                  <Text style={styles.tableHeader}>{t("common.table.liter")}</Text>
                  <Text style={styles.tableHeader}>{t("common.table.fat")}</Text>
                  <Text style={styles.tableHeader}>{t("common.table.snf")}</Text>
                  <Text style={styles.tableHeader}>{t("common.table.rate")}</Text>
                  <Text style={styles.tableHeaderlast}>{t("common.table.amount")}</Text>
                </View>
                {customerData.map((rowData, index) => (
                  <View key={index} style={styles.tableRow}>
                    <Text style={styles.tableCell}>{rowData.date.substr(5).split('-').reverse().join('/')}</Text>
                    <Text style={styles.tableCell}>{rowData.kno + ": " + rowData.cname}</Text>
                    <Text style={styles.tableCell}>{rowData.time}</Text>
                    <Text style={styles.tableCell}>{rowData.type}</Text>
                    <Text style={styles.tableCell}>{rowData.liter}</Text>
                    <Text style={styles.tableCell}>{rowData.fat}</Text>
                    <Text style={styles.tableCell}>{rowData.snf}</Text>
                    <Text style={styles.tableCell}>{rowData.rate}</Text>
                    <Text style={styles.tableCell}>{rowData.amt}</Text>
                    {/* Add more data cells as needed */}
                  </View>
                ))}
                <View style={styles.tableRow3}>
                  <Text style={styles.tableHeader}>{t("common.total")}</Text>
                  <Text style={styles.tableHeader}>{"-"}</Text>
                  <Text style={styles.tableHeader}>{"-"}</Text>
                  <Text style={styles.tableHeader}>{"-"}</Text>
                  <Text style={styles.tableHeader}>{totals.tliter}</Text>
                  <Text style={styles.tableHeader}>{"-"}</Text>
                  <Text style={styles.tableHeader}>{"-"}</Text>
                  <Text style={styles.tableHeader}>{"-"}</Text>
                  <Text style={styles.tableHeaderlast}>{totals.tamt}</Text>

                </View>
              </View>
            </Page>
            :
            localStorage.getItem("rtype") === "bydate" && localStorage.getItem("showmasik") === "false" ?
              <Page size="A4" orientation="landscape">
                <Text style={styles.latoText}>{localStorage.getItem("kendra")}</Text>
                <Text style={styles.latoText2}>{t("sanklanreportprint.titles.vadhtutSheet")}</Text>
                <Text style={styles.latoText2}>
                  {t("sanklanreportprint.period", {
                    from: formatDate(localStorage.getItem("date1print")),
                    to: formatDate(localStorage.getItem("date2print")),
                  })}
                </Text>

                <View style={styles.table}>

                  <View style={styles.tableRow}>
                    {
                      localStorage.getItem("type") === "Both" ?
                        <>
                          <Text style={[styles.tableHeadervadhtutspan, { flex: 2 }]}>-</Text>
                          <Text style={[styles.tableHeadervadhtutspan, { flex: 12 }]}>{t("sanklanreport.options.buffalo")}</Text>
                          <Text style={[styles.tableHeadervadhtutlastspan, { flex: 12 }]}>{t("sanklanreport.options.cow")}</Text>
                        </>
                        :
                        localStorage.getItem("type") === "Buffalo" ?
                          <>
                            <Text style={[styles.tableHeadervadhtutspan, { flex: 2 }]}>-</Text>
                            <Text style={[styles.tableHeadervadhtutspan, { flex: 12 }]}>{t("sanklanreport.options.buffalo")}</Text>

                          </>
                          : localStorage.getItem("type") === "Cow" ?
                            <>
                              <Text style={[styles.tableHeadervadhtutspan, { flex: 2 }]}>-</Text>
                              <Text style={[styles.tableHeadervadhtutspan, { flex: 12 }]}>{t("sanklanreport.options.cow")}</Text>

                            </>
                            : ''
                    }
                  </View>
                  {/* Table Header */}
                  <View style={styles.tableRow}>
                    <Text style={styles.tableHeadervadhtut}>{t("common.table.date")}</Text>
                    <Text style={styles.tableHeadervadhtut}>{t("common.table.time")}</Text>

                    {
                      localStorage.getItem("type") === "Both" ?
                        <>
                          <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.purchase")}</Text>
                          <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.unionSale")}</Text>
                          <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.secondaryMilk")}</Text>
                          <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.calfMilk")}</Text>
                          <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.retail")}</Text>
                          <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.purchaseAmt")}</Text>
                          <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.saleAmt")}</Text>
                          <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.secondaryAmt")}</Text>
                          <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.calfAmt")}</Text>
                          <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.retailAmt")}</Text>
                          <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.vadhtutLiter")}</Text>
                          <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.vadhtutRupee")}</Text>

                          <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.purchase")}</Text>
                          <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.unionSale")}</Text>
                          <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.secondaryMilk")}</Text>
                          <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.calfMilk")}</Text>
                          <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.retail")}</Text>
                          <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.purchaseAmt")}</Text>
                          <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.saleAmt")}</Text>
                          <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.secondaryAmt")}</Text>
                          <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.calfAmt")}</Text>
                          <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.retailAmt")}</Text>
                          <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.vadhtutLiter")}</Text>
                          <Text style={styles.tableHeadervadhtutlast}>{t("sanklanreportprint.tableVadhtut.vadhtutRupee")}</Text>
                        </>
                        : localStorage.getItem("type") === "Buffalo" ?

                          <>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.purchase")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.unionSale")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.secondaryMilk")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.calfMilk")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.retail")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.purchaseAmt")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.saleAmt")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.secondaryAmt")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.calfAmt")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.retailAmt")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.vadhtutLiter")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.vadhtutRupee")}</Text>
                          </>

                          : localStorage.getItem("type") === "Cow" ?

                            <>
                              <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.purchase")}</Text>
                              <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.unionSale")}</Text>
                              <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.secondaryMilk")}</Text>
                              <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.calfMilk")}</Text>
                              <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.retail")}</Text>
                              <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.purchaseAmt")}</Text>
                              <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.saleAmt")}</Text>
                              <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.secondaryAmt")}</Text>
                              <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.calfAmt")}</Text>
                              <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.retailAmt")}</Text>
                              <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.vadhtutLiter")}</Text>
                              <Text style={styles.tableHeadervadhtutlast}>{t("sanklanreportprint.tableVadhtut.vadhtutRupee")}</Text>
                            </>
                            : ''
                    }
                  </View>
                  {customerData.map((rowData, index) => (
                    <View key={index} style={styles.tableRow}>
                      <Text style={styles.tableCellvadhtut}>{formatDate(rowData.date)}</Text>
                      <Text style={styles.tableCellvadhtut}>{rowData.time}</Text>

                      {
                        localStorage.getItem("type") === "Both" ?
                          <>
                            <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.mhliter).toFixed(2)}</Text>
                            <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.sanghtotalmh).toFixed(2)}</Text>
                            <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.dlitermh).toFixed(2)}</Text>
                            <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vaslitermh).toFixed(2)}</Text>
                            <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.totalratibmh).toFixed(2)}</Text>
                            <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.mhamt).toFixed(2)}</Text>
                            <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.sanghamtmh).toFixed(2)}</Text>
                            <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.damtmh).toFixed(2)}</Text>
                            <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vasamtmh).toFixed(2)}</Text>
                            <Text style={styles.tableCellvadhtut}>{parseFloat(parseFloat(rowData.ratibamtmh && rowData.ratibamtmh !== "" ? rowData.ratibamtmh : 0) + parseFloat(rowData.ratibamtmhsabh && rowData.ratibamtmhsabh !== "" ? rowData.ratibamtmhsabh : 0)).toFixed(2)}</Text>
                            <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vadhtutmh).toFixed(2)}</Text>
                            <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vadhtutmhamt).toFixed(2)}</Text>

                            <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.gayliter).toFixed(2)}</Text>
                            <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.sanghtotalgay).toFixed(2)}</Text>
                            <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.dlitergay).toFixed(2)}</Text>
                            <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vaslitergay).toFixed(2)}</Text>
                            <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.totalratibgay).toFixed(2)}</Text>
                            <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.gayamt).toFixed(2)}</Text>
                            <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.sanghamtgay).toFixed(2)}</Text>
                            <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.damtgay).toFixed(2)}</Text>
                            <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vasamtgay).toFixed(2)}</Text>
                            <Text style={styles.tableCellvadhtut}>{parseFloat(parseFloat(rowData.ratibamtgay && rowData.ratibamtgay !== "" ? rowData.ratibamtgay : 0) + parseFloat(rowData.ratibamtgaysabh && rowData.ratibamtgaysabh !== "" ? rowData.ratibamtgaysabh : 0)).toFixed(2)}</Text>
                            <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vadhtutgay).toFixed(2)}</Text>
                            <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vadhtutgayamt).toFixed(2)}</Text>
                          </>

                          : localStorage.getItem("type") === "Buffalo" ?
                            <>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.mhliter).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.sanghtotalmh).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.dlitermh).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vaslitermh).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(parseFloat(rowData.totalratibmh) + parseFloat(rowData.totalratibmhsabh)).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.mhamt).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.sanghamtmh).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.damtmh).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vasamtmh).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(parseFloat(rowData.ratibamtmh && rowData.ratibamtmh !== "" ? rowData.ratibamtmh : 0) + parseFloat(rowData.ratibamtmhsabh && rowData.ratibamtmhsabh !== "" ? rowData.ratibamtmhsabh : 0)).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vadhtutmh).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vadhtutmhamt).toFixed(2)}</Text>
                            </>
                            : localStorage.getItem("type") === "Cow" ?
                              <>
                                <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.gayliter).toFixed(2)}</Text>
                                <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.sanghtotalgay).toFixed(2)}</Text>
                                <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.dlitergay).toFixed(2)}</Text>
                                <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vaslitergay).toFixed(2)}</Text>
                                <Text style={styles.tableCellvadhtut}>{parseFloat(parseFloat(rowData.totalratibgay) + parseFloat(rowData.totalratibgaysabh)).toFixed(2)}</Text>
                                <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.gayamt).toFixed(2)}</Text>
                                <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.sanghamtgay).toFixed(2)}</Text>
                                <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.damtgay).toFixed(2)}</Text>
                                <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vasamtgay).toFixed(2)}</Text>
                                <Text style={styles.tableCellvadhtut}>{parseFloat(parseFloat(rowData.ratibamtgay && rowData.ratibamtgay !== "" ? rowData.ratibamtgay : 0) + parseFloat(rowData.ratibamtgaysabh && rowData.ratibamtgaysabh !== "" ? rowData.ratibamtgaysabh : 0)).toFixed(2)}</Text>
                                <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vadhtutgay).toFixed(2)}</Text>
                                <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vadhtutgayamt).toFixed(2)}</Text>
                              </>
                              : ''
                      }
                    </View>
                  ))}

                  <View style={styles.tableRow3}>
                    <Text style={styles.tableHeadervadhtut}>{t("common.total")}</Text>
                    <Text style={styles.tableHeadervadhtut}>{" "}</Text>
                    {
                      localStorage.getItem("type") === "Both" ?
                        ''
                        : localStorage.getItem("type") === "Buffalo" ?

                          <>
                            <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tmhliter).toFixed(2)}</Text>
                            <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tsanghtotalmh).toFixed(2)}</Text>
                            <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tdlitermh).toFixed(2)}</Text>
                            <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tvaslitermh).toFixed(2)}</Text>
                            <Text style={styles.tableHeadervadhtut}>{parseFloat(parseFloat(totals.ttotalratibmh) + parseFloat(totals.ttotalratibmhsabh)).toFixed(2)}</Text>
                            <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tmhamt).toFixed(2)}</Text>
                            <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tsanghamtmh).toFixed(2)}</Text>
                            <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tdamtmh).toFixed(2)}</Text>
                            <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tvasamtmh).toFixed(2)}</Text>
                            <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tratibamtmh).toFixed(2)}</Text>
                            <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tvadhtutmh).toFixed(2)}</Text>
                            <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tvadhtutmhamt).toFixed(2)}</Text>
                          </>
                          : localStorage.getItem("type") === "Cow" ?
                            <>
                              <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tgayliter).toFixed(2)}</Text>
                              <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tsanghtotalgay).toFixed(2)}</Text>
                              <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tdlitergay).toFixed(2)}</Text>
                              <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tvaslitergay).toFixed(2)}</Text>
                              <Text style={styles.tableHeadervadhtut}>{parseFloat(parseFloat(totals.ttotalratibgay) + parseFloat(totals.ttotalratibgaysabh)).toFixed(2)}</Text>
                              <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tgayamt).toFixed(2)}</Text>
                              <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tsanghamtgay).toFixed(2)}</Text>
                              <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tdamtgay).toFixed(2)}</Text>
                              <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tvasamtgay).toFixed(2)}</Text>
                              <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tratibamtgay).toFixed(2)}</Text>
                              <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tvadhtutgay).toFixed(2)}</Text>
                              <Text style={styles.tableHeadervadhtutlast}>{parseFloat(totals.tvadhtutgayamt).toFixed(2)}</Text>
                            </>
                            : ''

                    }
                  </View>
                </View>

              </Page>
              :
              localStorage.getItem("rtype") === "bydate" && localStorage.getItem("showmasik") === "true" ?
                <Page size="A4" orientation="landscape">
                  <Text style={styles.latoText}>{localStorage.getItem("kendra")}</Text>
                  <Text style={styles.latoText2}>{t("sanklanreportprint.titles.vadhtutSheet")}</Text>
                  <Text style={styles.latoText2}>
                    {t("sanklanreportprint.period", {
                      from: formatDate(localStorage.getItem("date1print")),
                      to: formatDate(localStorage.getItem("date2print")),
                    })}
                  </Text>

                  <View style={styles.table}>

                    <View style={styles.tableRow}>
                      {
                        localStorage.getItem("type") === "Both" ?
                          <>
                            <Text style={[styles.tableHeadervadhtutspan, { flex: 2 }]}>-</Text>
                            <Text style={[styles.tableHeadervadhtutspan, { flex: 12 }]}>{t("sanklanreport.options.buffalo")}</Text>
                            <Text style={[styles.tableHeadervadhtutlastspan, { flex: 12 }]}>{t("sanklanreport.options.cow")}</Text>
                          </>
                          :
                          localStorage.getItem("type") === "Buffalo" ?
                            <>
                              <Text style={[styles.tableHeadervadhtutspan, { flex: 2 }]}>-</Text>
                              <Text style={[styles.tableHeadervadhtutspan, { flex: 12 }]}>{t("sanklanreport.options.buffalo")}</Text>

                            </>
                            : localStorage.getItem("type") === "Cow" ?
                              <>
                                <Text style={[styles.tableHeadervadhtutspan, { flex: 2 }]}>-</Text>
                                <Text style={[styles.tableHeadervadhtutspan, { flex: 12 }]}>{t("sanklanreport.options.cow")}</Text>

                              </>
                              : ''
                      }
                    </View>
                    {/* Table Header */}
                    <View style={styles.tableRow}>
                      <Text style={styles.tableHeadervadhtut}>{t("common.table.month")}</Text>
                      <Text style={styles.tableHeadervadhtut}>{"-"}</Text>

                      {
                        localStorage.getItem("type") === "Both" ?
                          <>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.purchase")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.unionSale")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.secondaryMilk")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.calfMilk")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.retail")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.purchaseAmt")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.saleAmt")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.secondaryAmt")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.calfAmt")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.retailAmt")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.vadhtutLiter")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.vadhtutRupee")}</Text>

                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.purchase")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.unionSale")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.secondaryMilk")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.calfMilk")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.retail")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.purchaseAmt")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.saleAmt")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.secondaryAmt")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.calfAmt")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.retailAmt")}</Text>
                            <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.vadhtutLiter")}</Text>
                            <Text style={styles.tableHeadervadhtutlast}>{t("sanklanreportprint.tableVadhtut.vadhtutRupee")}</Text>
                          </>
                          : localStorage.getItem("type") === "Buffalo" ?

                            <>
                              <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.purchase")}</Text>
                              <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.unionSale")}</Text>
                              <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.secondaryMilk")}</Text>
                              <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.calfMilk")}</Text>
                              <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.retail")}</Text>
                              <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.purchaseAmt")}</Text>
                              <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.saleAmt")}</Text>
                              <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.secondaryAmt")}</Text>
                              <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.calfAmt")}</Text>
                              <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.retailAmt")}</Text>
                              <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.vadhtutLiter")}</Text>
                              <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.vadhtutRupee")}</Text>
                            </>

                            : localStorage.getItem("type") === "Cow" ?

                              <>
                                <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.purchase")}</Text>
                                <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.unionSale")}</Text>
                                <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.secondaryMilk")}</Text>
                                <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.calfMilk")}</Text>
                                <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.retail")}</Text>
                                <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.purchaseAmt")}</Text>
                                <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.saleAmt")}</Text>
                                <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.secondaryAmt")}</Text>
                                <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.calfAmt")}</Text>
                                <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.retailAmt")}</Text>
                                <Text style={styles.tableHeadervadhtut}>{t("sanklanreportprint.tableVadhtut.vadhtutLiter")}</Text>
                                <Text style={styles.tableHeadervadhtutlast}>{t("sanklanreportprint.tableVadhtut.vadhtutRupee")}</Text>
                              </>
                              : ''
                      }
                    </View>
                    {customerData.map((rowData, index) => (
                      <View key={index} style={styles.tableRow}>
                        <Text style={styles.tableCellvadhtut}>{rowData.month_name}</Text>
                        <Text style={styles.tableCellvadhtut}>{"-"}</Text>

                        {
                          localStorage.getItem("type") === "Both" ?
                            <>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.mhliter).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.sanghtotalmh).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.dlitermh).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vaslitermh).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.totalratibmh).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.mhamt).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.sanghamtmh).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.damtmh).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vasamtmh).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(parseFloat(rowData.ratibamtmh && rowData.ratibamtmh !== "" ? rowData.ratibamtmh : 0) + parseFloat(rowData.ratibamtmhsabh && rowData.ratibamtmhsabh !== "" ? rowData.ratibamtmhsabh : 0)).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vadhtutmh).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vadhtutmhamt).toFixed(2)}</Text>

                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.gayliter).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.sanghtotalgay).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.dlitergay).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vaslitergay).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.totalratibgay).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.gayamt).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.sanghamtgay).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.damtgay).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vasamtgay).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(parseFloat(rowData.ratibamtgay && rowData.ratibamtgay !== "" ? rowData.ratibamtgay : 0) + parseFloat(rowData.ratibamtgaysabh && rowData.ratibamtgaysabh !== "" ? rowData.ratibamtgaysabh : 0)).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vadhtutgay).toFixed(2)}</Text>
                              <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vadhtutgayamt).toFixed(2)}</Text>
                            </>

                            : localStorage.getItem("type") === "Buffalo" ?
                              <>
                                <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.mhliter).toFixed(2)}</Text>
                                <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.sanghtotalmh).toFixed(2)}</Text>
                                <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.dlitermh).toFixed(2)}</Text>
                                <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vaslitermh).toFixed(2)}</Text>
                                <Text style={styles.tableCellvadhtut}>{parseFloat(parseFloat(rowData.totalratibmh) + parseFloat(rowData.totalratibmhsabh)).toFixed(2)}</Text>
                                <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.mhamt).toFixed(2)}</Text>
                                <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.sanghamtmh).toFixed(2)}</Text>
                                <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.damtmh).toFixed(2)}</Text>
                                <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vasamtmh).toFixed(2)}</Text>
                                <Text style={styles.tableCellvadhtut}>{parseFloat(parseFloat(rowData.ratibamtmh && rowData.ratibamtmh !== "" ? rowData.ratibamtmh : 0) + parseFloat(rowData.ratibamtmhsabh && rowData.ratibamtmhsabh !== "" ? rowData.ratibamtmhsabh : 0)).toFixed(2)}</Text>
                                <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vadhtutmh).toFixed(2)}</Text>
                                <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vadhtutmhamt).toFixed(2)}</Text>
                              </>
                              : localStorage.getItem("type") === "Cow" ?
                                <>
                                  <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.gayliter).toFixed(2)}</Text>
                                  <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.sanghtotalgay).toFixed(2)}</Text>
                                  <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.dlitergay).toFixed(2)}</Text>
                                  <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vaslitergay).toFixed(2)}</Text>
                                  <Text style={styles.tableCellvadhtut}>{parseFloat(parseFloat(rowData.totalratibgay) + parseFloat(rowData.totalratibgaysabh)).toFixed(2)}</Text>
                                  <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.gayamt).toFixed(2)}</Text>
                                  <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.sanghamtgay).toFixed(2)}</Text>
                                  <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.damtgay).toFixed(2)}</Text>
                                  <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vasamtgay).toFixed(2)}</Text>
                                  <Text style={styles.tableCellvadhtut}>{parseFloat(parseFloat(rowData.ratibamtgay && rowData.ratibamtgay !== "" ? rowData.ratibamtgay : 0) + parseFloat(rowData.ratibamtgaysabh && rowData.ratibamtgaysabh !== "" ? rowData.ratibamtgaysabh : 0)).toFixed(2)}</Text>
                                  <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vadhtutgay).toFixed(2)}</Text>
                                  <Text style={styles.tableCellvadhtut}>{parseFloat(rowData.vadhtutgayamt).toFixed(2)}</Text>
                                </>
                                : ''
                        }
                      </View>
                    ))}

                    <View style={styles.tableRow3}>
                      <Text style={styles.tableHeadervadhtut}>{t("common.total")}</Text>
                      <Text style={styles.tableHeadervadhtut}>{" "}</Text>
                      {
                        localStorage.getItem("type") === "Both" ?
                          ''
                          : localStorage.getItem("type") === "Buffalo" ?

                            <>
                              <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tmhliter).toFixed(2)}</Text>
                              <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tsanghtotalmh).toFixed(2)}</Text>
                              <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tdlitermh).toFixed(2)}</Text>
                              <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tvaslitermh).toFixed(2)}</Text>
                              <Text style={styles.tableHeadervadhtut}>{parseFloat(parseFloat(totals.ttotalratibmh) + parseFloat(totals.ttotalratibmhsabh)).toFixed(2)}</Text>
                              <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tmhamt).toFixed(2)}</Text>
                              <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tsanghamtmh).toFixed(2)}</Text>
                              <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tdamtmh).toFixed(2)}</Text>
                              <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tvasamtmh).toFixed(2)}</Text>
                              <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tratibamtmh).toFixed(2)}</Text>
                              <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tvadhtutmh).toFixed(2)}</Text>
                              <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tvadhtutmhamt).toFixed(2)}</Text>
                            </>
                            : localStorage.getItem("type") === "Cow" ?
                              <>
                                <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tgayliter).toFixed(2)}</Text>
                                <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tsanghtotalgay).toFixed(2)}</Text>
                                <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tdlitergay).toFixed(2)}</Text>
                                <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tvaslitergay).toFixed(2)}</Text>
                                <Text style={styles.tableHeadervadhtut}>{parseFloat(parseFloat(totals.ttotalratibgay) + parseFloat(totals.ttotalratibgaysabh)).toFixed(2)}</Text>
                                <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tgayamt).toFixed(2)}</Text>
                                <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tsanghamtgay).toFixed(2)}</Text>
                                <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tdamtgay).toFixed(2)}</Text>
                                <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tvasamtgay).toFixed(2)}</Text>
                                <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tratibamtgay).toFixed(2)}</Text>
                                <Text style={styles.tableHeadervadhtut}>{parseFloat(totals.tvadhtutgay).toFixed(2)}</Text>
                                <Text style={styles.tableHeadervadhtutlast}>{parseFloat(totals.tvadhtutgayamt).toFixed(2)}</Text>
                              </>
                              : ''

                      }
                    </View>
                  </View>

                </Page>
                : ''
        ) : ""}
      </Document>
    </PDFViewer>

  );

};

export default Sanklanreportprint;
